module.exports = __webpack_public_path__ + "img/activity_color.ed0b9bdd.png";